import styled, {keyframes} from 'styled-components'
import '../../fonts/_google_fonts.scss'
// Create the keyframes
const mainBlock = keyframes`
  0% {
    width: 0;
    left: 0;

  }
  50% {
    width: 100%;
    left: 0;

  }
  100% {
    width: 0;
    left: 100%;
  }
`
const secBlock = keyframes`
  0% {
    width: 0;
    left: 0;

  }
  50% {
    width: 100%;
    left: 0;

  }
  100% {
    width: 0;
    left: 100%;
  }
`
const mainFadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`
const popIn = keyframes`
  0% {
    width: 0;
    height: 0;
    background: #e9d856;
    border: 0 solid #ddd;
    opacity: 0;
  }
  50% {
    width: 10px;
    height: 10px;
    background: #e9d856;
    opacity: 1;
    bottom: 45px;
  }
   65% {
    height: 7px;
      bottom: 0;
      width: 15px
   }
   80% {
      width: 10px;
    height: 10px;
      bottom: 20px
   }
  100% {
    width: 7px;
    height: 7px;
    background: #e9d856;
    border: 0 solid #222;
    bottom: 13px;

  }
`
const secFadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`

// -CONTAINER
export const Container = styled.div<{ bgColor: string }>`
  width: 100%;
  height: 30%;
  background: ${props => props.bgColor
    ? props.bgColor
    : '#232323'};
  display: flex;
  justify-content: center;
  align-items: center;
`

// -CONTAINER -BOX
export const Box = styled.div`
    width: 250px;
    height: 250px;
    position: relative;
    display: flex;
    justify-content: center;
    flex-direction: column;
`

// -CONTAINER -BOX -TITLE
export const TitleContainer = styled.div`
      width: 100%;
      position: relative;
      display: flex;
      align-items: center;
      height: 50px;
`
export const BlockSpan = styled.span`
        width: 0;
        height: inherit;
        background: ${props => props.color
    ? props.color
    : '#ffb510'};
        position: absolute;
        animation: ${mainBlock} 2s cubic-bezier(.74, .06, .4, .92) forwards;
        display: flex;
`
export const Title = styled.h1<{ color: string }>`
        font-family: 'Poppins',sans-serif;
        color: ${props => props.color
    ? props.color
    : 'white'};
        font-size: 32px;
        -webkit-animation: ${mainFadeIn} 2s forwards;
        -o-animation: ${mainFadeIn} 2s forwards;
        animation: ${mainFadeIn} 2s forwards;
        animation-delay: 1.6s;
        opacity: 0;
        display: flex;
        align-items: baseline;
        position: relative;
`
export const AnimatedSpan = styled.span`
          width:0;
          height: 0;
          -webkit-border-radius: 50%;
          -moz-border-radius: 50%;
          border-radius: 50%;
          background: #ffb510;
          -webkit-animation: load 0.6s cubic-bezier(.74, .06, .4, .92) forwards;
          animation: ${popIn} 0.8s cubic-bezier(.74, .06, .4, .92) forwards;
          animation-delay: 2s;
          margin-left: 5px;
          margin-top: -10px;
          position: absolute;
          bottom: 13px;
          right: -12px;
`

// -CONTAINER -BOX -ROLE/SUBTITLE
export const Role = styled.div`
      width: 100%;
      position: relative;
      display: flex;
      align-items: center;
      height: 30px;
      margin-top: -10px;
`
export const BlockDiv = styled.div<{ color: string }>`
        width: 0;
        height: inherit;
       background: ${props => props.color
    ? props.color
    : '#e91e63'};
        position: absolute;
        animation: ${secBlock} 2s cubic-bezier(.74, .06, .4, .92) forwards;
        animation-delay: 2s;
        display: flex;
`
export const SubTitle = styled.h1<{ color: string }>`
        animation: ${secFadeIn} 2s forwards;
        animation-delay: 3.2s;
        opacity: 0;
        font-weight: 400;
        font-family: 'Lato',sans-serif;
        color: ${props => props.color
    ? props.color
    : '#ffffff'};
        font-size: 12px;
        text-transform: uppercase;
        letter-spacing: 5px;
`
